import { GameStyle } from "@lib/js-slingo-pawnshop-core/dist";
import { FeaturePurpleFishProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/features/purplefish/FeaturePurpleFishProperties";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { Point } from "pixi.js";
export class FeaturePurpleFishLandscapeProperties extends FeaturePurpleFishProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.cat.position.y = 564;
        this.cat.scale.set(0.9, 0.9);
        this.boxLeft.position.y = this.boxMiddle.position.y = this.boxRight.position.y = 410;
        this.logoProperties = new SpriteProperties(GameStyle.LOGO, GameStyle.MODULE, new Point(1509, 133), new Point(0.24, 0.24), new Point(0, 0));
    }
}
